<template>
  <v-row class="no-margin">
    <v-col class="alumni" cols="12" sm="12" md="12" lg="12">
      <h1 class="titlePage" id="alumni">Alumni</h1>
      <v-divider class="div-margin" />
    </v-col>

    <v-row class="no-margin" v-for="(title, index) in titles" :key="title">
      <v-col class="text" cols="12">
        <h1>{{title}}</h1>
      </v-col>

      <v-col cols="12">
        <v-container fluid class="no-pad">
          <v-layout row wrap>
            <v-flex xs12 sm6 md4 lg3 v-for="member in getType(index + 1)" :key="member.id">
              <v-card v-if="member.description.length>50" target="_blank" :to="`/team/members/${member.id}`" class="ma-2 height" min-height="500px" elevation="2" hover>
                <v-responsive class="member-title">
                  <img class="imwidth" height="350px" :src="member.photoUrl" />
                  <v-card-title class="member-title">{{member.name}} {{member.title}}</v-card-title>
                </v-responsive>
                <v-card-text
                  v-if="member.description.length>199"
                  class="text"
                >{{member.description.slice(0,100)+'...'+' more'}}</v-card-text>
                <v-card-text v-else class="text">{{member.description}}</v-card-text>
              </v-card>
              <v-card v-else class="ma-2 height" min-height="500px" elevation="2" hover>
                <v-responsive class="member-title">
                  <img class="imwidth" height="350px" :src="member.photoUrl" />
                  <v-card-title class="member-title">{{member.name}} {{member.title}}</v-card-title>
                </v-responsive>
                <v-card-text
                  v-if="member.description.length>199"
                  class="text"
                >{{member.description.slice(0,105)+'...'+' more'}}</v-card-text>
                <v-card-text v-else class="text">{{member.description}}</v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "AlumniComponents",
  data() {
    return {
      titles: [
        "Visiting Scholars",
        "Instructors",
        "Lab Managers",
        "Postdoctoral Research Fellows",
        "PhD Students",
        "Master Students",
        "Undergraduate Students",
        "High School Students",
      ]
    };
  },
  methods: {
    getType: function(type) {
      let x = this.alumniMembers.filter(
        doc => doc["type"] == type || (type == "6" && doc["type"] == "Others")
      );
      //console.log(x)
      x.sort(function(a, b) {
        var keyA = a.endperiod, keyB = b.endperiod;

        // Compare the 2 dates
        if (keyA < keyB) return 1;
        if (keyA > keyB) return -1;
        return 0;
      });
      return x
    }
  },
  computed: {
    ...mapState(["loadingMembers"]),
    ...mapGetters(["alumniMembers"])
  },
  mounted() {
    if (!this.alumniMembers.length) this.$store.dispatch("cargarMembers");
  }
};
</script>

<style scoped>
.text {
  text-align: justify;
  font-size: 1rem !important;
  word-break: break-word;
}

.alumni {
  align-content: center;
  text-align: center;
  font-size: 2.5rem;
  word-break: break-word;
}

.no-margin {
  margin: 0 !important;
}

.no-pad {
  padding-top: 0 !important;
}

.height{
  height:"500px" !important;
}

.member-title {
  padding-bottom: 0;
  padding-top: 0;
  font-size: 1.2rem;
  text-align: center !important;
  font-weight: bold;
  word-break: break-word;
}

.member-subtitle {
  padding-bottom: 5;
  padding-top: 5;
  word-break: break-word;
}

.div-margin {
  margin: 1rem 10rem 0rem 10rem;
}

.imwidth {
  max-width: 100%;
}

@media only screen and (max-width: 600px) {
  .imwidth {
    width: 100%;
  }
}
</style>